<script>
import NavBarRoutes from './nav-bar-routes'

export default {
  components: { NavBarRoutes },
  data: () => ({
    navRoutes: [
      {
        name: 'member-profile',
        title: 'Profile',
      },
      {
        name: 'member-booking-history',
        title: 'Booking History',
      },
      {
        name: 'member-vouchers',
        title: 'My Vouchers',
      },
      {
        name: 'member-redeem',
        title: 'Redeem Point',
      },
    ],
  }),
}
</script>

<template>
  <section class="bg-gray-200">
    <div class="container container-page mx-auto">
      <nav class="px-6">
        <ul class="flex overflow-x-auto">
          <NavBarRoutes :routes="navRoutes" />
        </ul>
      </nav>
    </div>
  </section>
</template>
